// The customer sign-up form /start makes for the merchant. Field objects are
// the same shape (and use the same translated labels) as the dashboard's form
// editor, which recognises its predefined fields by type + label: built any
// other way, the dashboard would show them as custom fields.

export function escapeHtml(text) {
  return String(text ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function buildFormFields(t, { phone = false, birthday = false, marketing = true } = {}) {
  const fields = [
    {
      type: "text",
      label: t("forms.new.initial.name"),
      unique: false,
      required: true,
      placeholder: t("forms.new.initial.placeholder.name"),
      field: "name",
    },
    {
      type: "email",
      label: t("forms.new.initial.email"),
      unique: true,
      required: true,
      placeholder: t("forms.new.initial.placeholder.email"),
      field: "email",
    },
  ];
  if (phone) {
    // Email stays the unique field, so phone is not (the form editor does the
    // same when phone is switched on next to email).
    fields.push({
      type: "tel",
      label: t("forms.new.initial.phone"),
      unique: false,
      required: false,
      placeholder: t("forms.new.initial.placeholder.phone"),
      field: "phone",
    });
  }
  if (birthday) {
    fields.push({
      type: "date",
      label: t("forms.new.initial.birthday"),
      unique: false,
      required: false,
      placeholder: t("forms.new.initial.placeholder.birthday"),
      field: "birthday",
    });
  }
  if (marketing) {
    fields.push({
      type: "checkbox",
      label: t("forms.new.initial.marketing"),
      unique: false,
      required: false,
      field: "marketing",
      options: [t("forms.new.initial.marketing")],
    });
  }
  return fields;
}

// One line telling customers what they get, written from the card. Plain text;
// formDescriptionHtml wraps it for the form.
export function formDescriptionText(draft, t) {
  const type = draft.cardType || "stamp";
  switch (type) {
    case "stamp":
      return t("start.form.description.stamp", {
        reward: String(draft.reward || "").trim(),
        count: Number(draft.stampCount) || 8,
      });
    case "discount":
      return t("start.form.description.discount", { discount: Number(draft.discount) || 0 });
    case "coupon":
      return t("start.form.description.coupon", { offer: String(draft.couponOffer || "").trim() });
    default:
      return t(`start.form.description.${type}`);
  }
}

export function formDescriptionHtml(text) {
  return `<p style="text-align: center">${escapeHtml(text)}</p>`;
}

export function buildFormPayload({ passId, draft, t, lang, backgroundColor, textColor }) {
  return {
    kind: 0,
    pass_id: passId,
    description: formDescriptionHtml(formDescriptionText(draft, t)),
    submit_text: t("forms.new.initial.submitText"),
    content: { fields: buildFormFields(t, draft.form) },
    background_color: backgroundColor,
    text_color: textColor,
    lang,
  };
}
